import React from "react";
import PropTypes from "prop-types";
import { Button, Card, Col, Row, Image } from "react-bootstrap";
import { Link } from "react-router-dom";
import "./movie-card.scss";

export class MovieCard extends React.Component {
  render() {
    const { movie } = this.props;

    return (
      <div className="card-rows">
        <Card className="movie-card d-flex">
          <Image className="image" variant="top" src={movie.ImagePath} fluid />
          <Card.Body>
            <Card.Title>{movie.Title}</Card.Title>

            <Link to={`/movies/${movie._id}`}>
              <Button variant="danger" className="align-self-end">
                View Details
              </Button>
            </Link>
          </Card.Body>
        </Card>
      </div>
    );
  }
}

MovieCard.propTypes = {
  movie: PropTypes.shape({
    Title: PropTypes.string.isRequired,
    ImagePath: PropTypes.string.isRequired,
  }).isRequired,
};
